import { FC } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import classNames from 'classnames';

import getClassNames from 'src/common/utils/getClassNames';
import ActionSheet from 'src/common/components/ActionSheet';
import Dropdown from 'src/common/components/Dropdown';
import Icon from 'src/common/components/IconDS22';
import AdminNavigation from '../Navigation';
import styles from './NavigationDropdown.module.scss';

const iconsMap = {
  account: 'person',
  'add-ons': 'basket',
  listing: 'listings',
  listings: 'listings',
  payments: 'payment',
  profile: 'profile',
  checkout: 'link',
  settings: 'gear',
  transactions: 'bank',
  security: 'lock',
};

type AdminNavigationDropdownProps = {
  variant?: 'with-back-button';
  fullWidth?: boolean;
};

const AdminNavigationDropdown: FC<AdminNavigationDropdownProps> = ({
  variant,
  fullWidth = false,
}) => {
  const [t] = useTranslation('navbar');
  const { pathname } = useRouter();
  const page = pathname.split('/').filter((s) => !!s)[1];

  return (
    <Dropdown
      className={getClassNames(styles, 'root', classNames(variant, { fullWidth }))}
      disableOnClickOutside
    >
      {({ close, isOpen, toggle }) => (
        <>
          <button
            type="button"
            onClick={toggle}
            className={getClassNames(styles, 'button', classNames({ open: isOpen, fullWidth }))}
            aria-label="Owner's menu"
          >
            <Icon id={iconsMap[page]} />
            {t(`admin-${page}`)}
            <Icon
              id="caret-down"
              className={styles.chevron}
              size="xs"
            />
          </button>
          <ActionSheet
            close={close}
            isOpen={isOpen}
          >
            <AdminNavigation
              close={close}
              variant="mobile"
            />
          </ActionSheet>
        </>
      )}
    </Dropdown>
  );
};

export default AdminNavigationDropdown;
